import { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'
import { integrationClient } from './integrationClient'

const integrationRequest = async <T>(options: AxiosRequestConfig) => {
  const onSuccess = (response: AxiosResponse<T>) => {
    const { data } = response
    return data
  }

  const onError = (error: AxiosError) => {
    return Promise.reject(error)
  }

  return integrationClient(options).then(onSuccess).catch(onError)
}

export default integrationRequest
